export type PriceFormat = {
  price    : number;
  currency?: string;
  locale?  : Intl.UnicodeBCP47LocaleIdentifier;
};

export const formatPrice = ({ price, currency, locale = "en-us" }: PriceFormat) => {
  if (!price) {
    return "";
  }

  if (!currency) {
    return price;
  }

  return new Intl
    .NumberFormat(locale, {
      style                : "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2 })
    .format(price);
};
